import { SchemaEmail, SchemaTimestamp, ZodArrayToEnum } from '@axiom/types';
import { z } from 'zod';
import { InterviewAttendeeResponses } from '@axiom/const';

import { CandidateSchema } from './candidate';

const InviteContactSchema = z.object({
  calendar: z
    .object({
      timezone: z.string().nullable(),
    })
    .nullable(),
  email: SchemaEmail.nullable(),
  fullName: z.string().nullable(),
  id: z.string().uuid(),
});

export type InviteContactType = z.infer<typeof InviteContactSchema>;

const CalendarConversationCandidateSchema = CandidateSchema.pick({
  calculatedDisplayName: true,
  profileImageKey: true,
  profileImageName: true,
}).extend({
  email: SchemaEmail.nullable(),
  calendar: z
    .object({
      timezone: z.string().nullable(),
    })
    .nullable(),
});

export type CalendarConversationCandidateType = z.infer<
  typeof CalendarConversationCandidateSchema
>;

const CalendarConversationInviteeSchema = z.object({
  adhocAttendee: z
    .object({
      firstName: z.string().nullable(),
      lastName: z.string().nullable(),
      email: SchemaEmail.nullable(),
    })
    .nullable(),
  attendeeResponse: z.enum(
    ZodArrayToEnum(Object.values(InterviewAttendeeResponses))
  ),
  candidate: CalendarConversationCandidateSchema.nullable(),
  contact: InviteContactSchema.nullable(),
  id: z.string().uuid(),
});

export type CalendarConversationInviteeType = z.infer<
  typeof CalendarConversationInviteeSchema
>;

const CalendarConversationParticipantSchema = z.object({
  meetingJoinedAt: SchemaTimestamp,
  participantName: z.string(),
});

export type CalendarConversationParticipantType = z.infer<
  typeof CalendarConversationParticipantSchema
>;

export const MeetingLinkTypeValues = ['ZOOM', 'MANUAL'] as const;
export type MeetingLinkType = (typeof MeetingLinkTypeValues)[number];

export const CalendarConversationSchema = z.object({
  cancelled: z.boolean().default(false),
  endTime: SchemaTimestamp,
  id: z.string().uuid(),
  invitees: z.array(CalendarConversationInviteeSchema),
  meetingLink: z.string().nullable(),
  meetingLinkType: z.enum(MeetingLinkTypeValues).nullable(),
  participants: z.array(CalendarConversationParticipantSchema).nullable(),
  startTime: SchemaTimestamp,
  unavailableAlertSentAt: SchemaTimestamp.nullable(),
});

export type CalendarConversationType = z.infer<
  typeof CalendarConversationSchema
>;
